export const getHomePageUrl = (locale: string) => `/${locale}/`;
export const getContactPageUrl = (locale: string) => `/${locale}/contact`;
export const getCmsCategoryUrl = (locale: string) => `/${locale}/:slug`;
export const getCmsArticleUrl = (locale: string) =>
	`/${locale}/:slug/:articleId`;
